import React, { useState, useEffect } from 'react';
import { amountTxt, sliderStyle, sliderTrack, sliderHandle, StyleLabelSlider, subtitleTxt, valueIcon } from '../../styles/StepsStyles';
import { SliderMarks } from 'antd/lib/slider';
import Slider from 'antd/lib/slider';
import { message } from 'antd';
import { useAppSelector, useAppDispatch } from '../../hooks/storeHooks';
import { getAssetDownPayment, getAssetDownPaymentHasError } from '../../reducer/slices/DataCotizador';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { formatNumber } from '../../functions/formatPrice';
import { Tooltip } from '@mui/material';
import { Col, Grid, Row } from 'antd';
import { InputPrice } from '../Inputs/Inputs';

 const SliderEnganche = () => {
    const dispatch = useAppDispatch();
    const dataCotizador = useAppSelector(state => state.DataCotizador);
    const dataResponse = useAppSelector(state => state.DataResponse);
    const [Enganche, setEnganche] = useState<number | string | undefined>();

    // Límites de negocio para el pago inicial
    const MAX_PERCENT = 35;      // El slider no puede superar el 35% del valor del activo
    const MAX_AMOUNT = 350000;   // El monto absoluto no puede superar $350,000 MXN
    const [downPaymentError, setDownPaymentError] = useState<string>('');
    const [minimo, setMinimo] = useState(0);
    const [advance, setAdvance] = useState({
        defaultValue: 0,
        value: 0
    });
    const { width } = useAppSelector(state => state.dimensions);

    useEffect(() => {
        const valueMinimo = dataResponse.ObjCanalArrendamiento.length !== 0 ?
            dataResponse.ObjCanalArrendamiento[dataCotizador.userPlazo]?.AnticipoMinimo:
            0;
        setMinimo(valueMinimo);
        setAdvance({ value: valueMinimo, defaultValue: valueMinimo });
        if(dataCotizador.assetPrice !== undefined){
            const newDownPayment = dataCotizador.assetPrice * (+valueMinimo / 100);
            dispatch(getAssetDownPayment(newDownPayment));
            // '' limpia NumericFormat de forma confiable; undefined es ignorado por el componente
            setEnganche(!newDownPayment ? '' : +newDownPayment.toFixed(2));
            setAdvance({ value: +valueMinimo, defaultValue: +valueMinimo });
        } else {
            setEnganche('');
        }
        // Se limpia el error al cambiar el precio del activo
        setDownPaymentError('');
        dispatch(getAssetDownPaymentHasError(false));

    }, [dataCotizador.userPlazo, dataResponse.ObjCanalArrendamiento, dataCotizador.assetPrice]);

    // Se usa '' en lugar de 0/undefined: NumericFormat limpia el campo con string vacío
    // pero ignora undefined (lo trata como "sin control") causando que no se limpie el input
    useEffect(() => {
        const amt = dataCotizador.assetDownPayment;
        setEnganche(!amt ? '' : +amt.toFixed(2));
    }, [dataCotizador.assetDownPayment])

    const onChangeEnganche = (value: string | number | undefined) => {
        if (value === undefined || value === null) return;
        const numValue = +value;
        if (isNaN(numValue) || !dataCotizador.assetPrice) return;
        const valueMinimo = dataResponse.ObjCanalArrendamiento.length !== 0 ?
            dataResponse.ObjCanalArrendamiento[dataCotizador.userPlazo]?.AnticipoMinimo : 0;
        const porcent = (numValue / dataCotizador.assetPrice) * 100;

        if (porcent > MAX_PERCENT) {
            const cappedAmount = dataCotizador.assetPrice * (MAX_PERCENT / 100);
            const hasError = numValue > MAX_AMOUNT;
            if (hasError) {
                // Se envía el valor real capturado para que el resumen muestre
                // lo mismo que el input. La navegación se bloquea en ValidateLeasingFirstStep
                // porque assetDownPayment > 350,000
                dispatch(getAssetDownPayment(numValue));
            } else {
                // El porcentaje supera el 35% pero el monto es válido:
                // se recorta silenciosamente al máximo permitido
                dispatch(getAssetDownPayment(cappedAmount));
                setEnganche(cappedAmount); // Fuerza la actualización visual del input
            }
            setAdvance({ defaultValue: MAX_PERCENT, value: MAX_PERCENT });
            setDownPaymentError(hasError ? 'El pago inicial no debe superar $350,000 MXN o el 35% del valor del vehículo' : '');
            dispatch(getAssetDownPaymentHasError(hasError));
        } else if (porcent < 1) {
            // El monto es menor al mínimo requerido: se restablece al porcentaje mínimo
            dispatch(getAssetDownPayment(dataCotizador.assetPrice * (+valueMinimo / 100)));
            setAdvance({ value: +valueMinimo, defaultValue: +valueMinimo });
            setDownPaymentError('');
            dispatch(getAssetDownPaymentHasError(false));
        } else {
            dispatch(getAssetDownPayment(numValue));
            setAdvance({ value: +porcent.toFixed(2), defaultValue: +porcent.toFixed(2) });
            const hasError = numValue > MAX_AMOUNT;
            setDownPaymentError(hasError ? 'El pago inicial no debe superar $350,000 MXN o el 35% del valor del vehículo' : '');
            dispatch(getAssetDownPaymentHasError(hasError));
        }
    }


    const advanceMarks: SliderMarks = {
        0: { label: '' },
        [advance.value]: { style: StyleLabelSlider, label: `${advance.value}%` },
        [MAX_PERCENT]: advance.value <= MAX_PERCENT
            ? { style: StyleLabelSlider, label: `${MAX_PERCENT}%` }
            : { style: StyleLabelSlider, label: '' },
    };
    const onChangeAdvanceValue = (value: number) => {
        if (dataCotizador.assetPrice !== undefined) {
            const amount = dataCotizador.assetPrice * (value / 100);
            dispatch(getAssetDownPayment(amount));
            const hasError = amount > MAX_AMOUNT;
            setDownPaymentError(hasError ? `El pago inicial no debe superar $350,000 MXN o el 35% del valor del vehículo` : '');
            dispatch(getAssetDownPaymentHasError(hasError));
        }
        setAdvance({ ...advance, value });
        // Si el usuario arrastra por debajo del mínimo, se regresa al valor mínimo tras 400ms
        if (value < minimo)
            setTimeout(() => {
                setAdvance({ value: minimo, defaultValue: minimo });
                if (dataCotizador.assetPrice !== undefined) {
                    dispatch(getAssetDownPayment(dataCotizador.assetPrice * (minimo / 100)));
                    dispatch(getAssetDownPaymentHasError(false));
                }
            }, 400);
    }

    return (
<>
    <p style={{ ...subtitleTxt, textAlign: "center" }}>
        Pago inicial
        <Tooltip
            placement={width <= 700 ? "top" : "right"}
            enterTouchDelay={0}
            leaveTouchDelay={4000}
            title={`Mínimo el ${minimo}%`}
        >
            <QuestionCircleOutlined style={valueIcon} />
        </Tooltip>
    </p>

    <Row gutter={[16, 16]} align="middle">
            <Col xs={24} sm={24} md={12}>
            <Slider
                id='advanceSlider'
                marks={advanceMarks}
                min={0}
                max={MAX_PERCENT}
                step={5}
                value={advance.value}
                defaultValue={advance.defaultValue}
                onChange={(value) => onChangeAdvanceValue(value)}
                style={sliderStyle}
                handleStyle={sliderHandle}
                trackStyle={sliderTrack}
                tooltip={{ formatter: null }}
            />
        </Col>
        <Col xs={24} sm={24} md={12}>
                    <InputPrice isPrice value={Enganche} label="" onChange={onChangeEnganche} fullWidth={false} isNumber />
        </Col>
    </Row>
    {/* Mensaje de error visible cuando el monto supera $350,000 MXN */}
    {downPaymentError && (
        <p style={{ color: 'red', fontSize: '12px', marginTop: '4px', textAlign: 'center' }}>
            {downPaymentError}
        </p>
    )}
</>
    )

 }

 export default SliderEnganche
